var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAtm = function SvgAtm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#26BAB9",
    fillRule: "evenodd",
    d: "M0 5.5A1.5 1.5 0 0 1 1.5 4h21A1.5 1.5 0 0 1 24 5.5v12.75a1.5 1.5 0 0 1-1.5 1.5h-21a1.5 1.5 0 0 1-1.5-1.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.463 15.441H8.05l-.563-1.463H4.911l-.531 1.463H3L5.509 9h1.375zM7.07 12.893l-.888-2.39-.87 2.39zM10.94 15.441V10.09H9.028V9h5.12v1.09H12.24v5.351zM14.973 15.441V9h1.947l1.168 4.394L19.245 9h1.951v6.441h-1.208v-5.07l-1.279 5.07h-1.252l-1.274-5.07v5.07z"
  })));
};
export default SvgAtm;